import { useEffect, useState } from "react";

/**
 * Custom cursor — a subtle blue dot that follows the mouse plus a
 * soft outline ring lagging behind. Auto-hides on touch devices.
 */
export default function CustomCursor() {
    const [pos, setPos] = useState({ x: -100, y: -100 });
    const [ringPos, setRingPos] = useState({ x: -100, y: -100 });
    const [hover, setHover] = useState(false);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        // Skip on touch devices
        if (typeof window === "undefined") return;
        const isTouch = matchMedia("(hover: none), (pointer: coarse)").matches;
        if (isTouch) return;

        let ringX = -100;
        let ringY = -100;
        let dotX = -100;
        let dotY = -100;
        let raf;

        const onMove = (e) => {
            dotX = e.clientX;
            dotY = e.clientY;
            setVisible(true);
            setPos({ x: dotX, y: dotY });
        };

        const onOver = (e) => {
            const t = e.target;
            if (t && t.closest("a, button, [role='button'], input, textarea, select, [data-cal-link]")) {
                setHover(true);
            } else {
                setHover(false);
            }
        };

        const onLeave = () => setVisible(false);

        const loop = () => {
            ringX += (dotX - ringX) * 0.18;
            ringY += (dotY - ringY) * 0.18;
            setRingPos({ x: ringX, y: ringY });
            raf = requestAnimationFrame(loop);
        };

        window.addEventListener("mousemove", onMove, { passive: true });
        window.addEventListener("mouseover", onOver, { passive: true });
        window.addEventListener("mouseleave", onLeave);
        raf = requestAnimationFrame(loop);
        return () => {
            window.removeEventListener("mousemove", onMove);
            window.removeEventListener("mouseover", onOver);
            window.removeEventListener("mouseleave", onLeave);
            if (raf) cancelAnimationFrame(raf);
        };
    }, []);

    if (!visible) return null;

    return (
        <>
            <div
                className="pointer-events-none fixed z-[9999] transition-[width,height,opacity] duration-200"
                style={{
                    left: pos.x,
                    top: pos.y,
                    width: hover ? 10 : 6,
                    height: hover ? 10 : 6,
                    transform: "translate(-50%, -50%)",
                    background: "#0090FF",
                    borderRadius: 999,
                    mixBlendMode: "difference",
                }}
                aria-hidden
            />
            <div
                className="pointer-events-none fixed z-[9998] transition-[width,height,border-color,background] duration-200"
                style={{
                    left: ringPos.x,
                    top: ringPos.y,
                    width: hover ? 56 : 34,
                    height: hover ? 56 : 34,
                    transform: "translate(-50%, -50%)",
                    border: `1px solid ${hover ? "#0090FF" : "rgba(255,255,255,0.35)"}`,
                    background: hover ? "rgba(0,144,255,0.08)" : "transparent",
                    borderRadius: 999,
                }}
                aria-hidden
            />
        </>
    );
}
